import Cookies from 'js-cookie';

// Constant
const USER_TOKEN = 'access_token';
const EXTERNAL_ACCOUNT_ID = 'external_account_id';

// 1) Link email
const linkEmailWithAccount = async (user_token , email) => {
  const LINK_EMAIL_API_URL =
    'https://django-cloudrun-5cc2zmgpqq-lz.a.run.app/api/clients/integrations/'+email+'/link';

  try {
    const response = await fetch(LINK_EMAIL_API_URL, {
      method: 'get',
      headers: {
        Authorization: `${user_token}`,
      },
    });
    const body = await response.json();
    if (response.status === 200 && !body.error) {
      return body.results;
    } else {
      alert('something went wrong');
      return null;
    }
  } catch (error) {
    console.error(error);
  }
};

// 2) Navigate to import page with accountId
const setIdAndNavigateToImportPage = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const isLinked = searchParams.get('linked');
  const externalAccountId = searchParams.get(EXTERNAL_ACCOUNT_ID);

  if (isLinked === 'true') {
 
    // Reset the URL parameters
    // window.history.replaceState({}, document.title, location.pathname);
    if (!Cookies.get(EXTERNAL_ACCOUNT_ID))
      Cookies.set(EXTERNAL_ACCOUNT_ID, externalAccountId);
    return externalAccountId;
  }
  return null;
};

// On importEmailsRecieptspage

// 3) get user access id
const getExternalAccountId = () => {
  const externalAccountId = Cookies.get(EXTERNAL_ACCOUNT_ID);
  if (externalAccountId) {
    return externalAccountId;
  }

  return null;
};

// 4) unlink email
// const unlinkEmail = async (user_token, external_account_id) => {
//   try {
//     const res = await fetch( LINK_EMAIL_API_URL, {
//       method: 'post',
//       headers: {
//         Authorization: `${user_token}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         external_account_id: external_account_id,
//       }),
//     });

//     if (!res.ok) {
//       throw new Error(`Request failed with status ${res.status}`);
//     }
//   } catch (error) {
//     console.error('Error:', error.message);
//   }
// };

// 5) get email receipts
// 1) Link email


const GetReceiptFromEmail = async (user_token , email ,externalAccountId  ) => {
  const LINK_EMAIL_API_URL =
    'https://django-cloudrun-5cc2zmgpqq-lz.a.run.app/api/clients/integrations/'+email+'/emails';
 
  try {
    const response = await fetch(LINK_EMAIL_API_URL, {
      method: 'post',
      body: JSON.stringify({ external_account_id: externalAccountId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${user_token}`,
      },
    });
    const body = await response.json();
    if (response.status === 200 && !body.error) {
      return body.message;
    } else {
      alert('something went wrong');
      return null;
    }
  } catch (error) {
    console.error(error);
  }
};

export {
  linkEmailWithAccount,
  setIdAndNavigateToImportPage,
  getExternalAccountId,
  GetReceiptFromEmail,
  USER_TOKEN,
  EXTERNAL_ACCOUNT_ID,
};
